"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.title = exports.tag = exports.body = void 0;
var _colors = require("./colors");
const tag = {
  fontWeight: 500,
  lineHeight: 18,
  size: 14
};

// Field labels, section headers
exports.tag = tag;
const title = {
  lineHeight: 18,
  size: 13,
  color: _colors.neutralDark30
};
exports.title = title;
const body = {
  fontWeight: 400,
  lineHeight: 18,
  size: 15,
  color: _colors.neutralDark40
};
exports.body = body;
//# sourceMappingURL=typography.js.map